<div class="dialog__container assistance-coverages-comparison assistance-coverages-comparison--ac"
     [ngClass]="{
        'assistance-coverages-comparison--without-prices': !pricesVisible,
        'assistance-coverages-comparison--wide': wideComparison
        }"
>
  <div class="dialog__header">

    <div class="dialog__close"
         [ngClass]="{
          'opacity-0': !dialogCloseVisible,
          'opacity-1': dialogCloseVisible
         }"
         (click)="close()" cdkFocusRegionstart>
      <span class="material-icons">close</span>
    </div>

    <div class="two-container">
      <div class="dialog__title">
        <span class="dialog__title--text">{{ 'AC_VARIANTS_COMPARISON.DIALOG.title' | translate }}</span>
      </div>
    </div>
  </div>

  <div class="assistance-coverages-comparison__table">
    <div *ngFor="let config of coveragesConfig" class="assistance-coverages-comparison__table__row">
      <div class="assistance-coverage__label">
        {{ getCoverageLabel(config.coverageName) | translate }}

        <app-tooltip-icon *ngIf="config.tooltip" class="reset-position"
                          [outlined]="true"
                          [description]="config.tooltip"></app-tooltip-icon>
      </div>

      <div class="assistance-coverage__values">
          <ng-container *ngFor="let variant of variantsOrder">
              <app-assistance-coverage-value *ngIf="hasVariant(variant)" class="assistance-coverage__value" [value]="getVariantValue(variant, config)" [isAmount]="config.isAmount"></app-assistance-coverage-value>
          </ng-container>
      </div>
    </div>
  </div>

  <div class="assistance-coverages-comparison__pricing-row">
    <div class="assistance-coverages-comparison__pricing-row__label">
        <ng-container *ngIf="pricesVisible">
            {{ 'ASSISTANCE_COVERAGES_COMPARISON.variantPrice' | translate | uppercase }}
        </ng-container>
    </div>
    <div class="assistance-coverages-comparison__pricing-row__prices">
      <div *ngFor="let pricingItem of pricingData" class="assistance-coverages-comparison__pricing-row__price">
        <app-offer-modification-price *ngIf="pricingItem.price" [price]="pricingItem.price"> </app-offer-modification-price>
        <button class="btn btn--secondary btn--small-padding" (click)="selectAssistance(pricingItem.name)">
          {{'ASSISTANCE_COVERAGES_COMPARISON.choose' | translate}}
        </button>
      </div>
    </div>
  </div>

</div>
